import React from 'react';
import { Box, Typography } from '@mui/material';
import { ColorBlock, SectionHeading, BodyText, BLOCKS, P, PD, A } from './BlogShared.jsx';

const Check = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="10" fill={`${P}12`} />
    <path d="M6 10l3 3 5-6" stroke={P} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Cross = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="10" fill="rgba(0,0,0,0.04)" />
    <path d="M7 7l6 6M13 7l-6 6" stroke="rgba(0,0,0,0.25)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const features = [
  'AI-powered demand forecasting',
  'Multi-outlet management',
  'Automatic waste tracking',
  'Role-based staff access',
  'Inventory intelligence & alerts',
  'Built for Indian F&B',
];

export const ComparisonSection = () => (
  <ColorBlock bg={BLOCKS.lavender} innerBg="white" innerRadius="32px">
    <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 7 } }}>
      <SectionHeading size="md" align="center" sx={{ color: PD, mb: 2 }}>
        Why Karobar <Box component="span" sx={{ fontFamily: "'Instrument Serif', serif", fontWeight: 700, fontStyle: 'italic' }}>stands out</Box>
      </SectionHeading>
      <BodyText align="center" sx={{ maxWidth: 500, mx: 'auto' }}>
        Most tools just digitize your bills. Karobar transforms how you think about your business.
      </BodyText>
    </Box>

    {/* Comparison table */}
    <Box sx={{ maxWidth: 680, mx: 'auto' }}>
      {/* Header row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 100px 100px',
          gap: 1,
          mb: 1.5,
          px: { xs: 1, md: 2 },
        }}
      >
        <Box />
        <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: P, textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Karobar
        </Typography>
        <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: 'rgba(0,0,0,0.35)', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Others
        </Typography>
      </Box>

      {/* Feature rows */}
      {features.map((feat, i) => (
        <Box
          key={feat}
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 100px 100px',
            gap: 1,
            py: 1.8,
            px: { xs: 1, md: 2 },
            borderRadius: '12px',
            background: i % 2 === 0 ? 'rgba(255,255,255,0.5)' : 'transparent',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ fontSize: '0.88rem', fontWeight: 500, color: 'rgba(0,0,0,0.7)' }}>
            {feat}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Check />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Cross />
          </Box>
        </Box>
      ))}
    </Box>
  </ColorBlock>
);
